import { formatDistanceToNow } from 'date-fns';
import dayjs, { extend } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

export function fDate(date?: string | null, newFormat?: string) {
  extend(utc);
  extend(timezone);
  const fm = newFormat || 'DD.MM.YYYY';

  return date ? dayjs(date).tz(dayjs.tz.guess()).format(fm) : '';
}

export function fDateTime(date?: string | null, newFormat?: string) {
  extend(utc);
  extend(timezone);
  const fm = newFormat || 'DD.MM.YYYY HH:mm';

  return date ? dayjs(date).tz(dayjs.tz.guess()).format(fm) : '';
}

export function fToNow(date: Date) {
  return date
    ? formatDistanceToNow(date, {
        addSuffix: true,
      })
    : '';
}
